// extracted by mini-css-extract-plugin
module.exports = {"container":"instructions_container__1hgAh","inner":"instructions_inner__1QDgU","mobile":"instructions_mobile__2wjnl","left":"instructions_left__3-GbL"};